import _ from 'lodash';
import textStyle from './text-style';
import { getFeatureTagStyle, getSavedTagStyles, saveTagStyle } from '../../layers/Leaflet/VectorLayer/TagStyleStorage';

/**
 * Opens the shared text-style dialog for a single feature's name tag.
 * Reuses the global tag options as defaults, merges any previously saved
 * per-feature override on top, and persists the edited style locally.
 *
 * @param {Object}   config
 * @param {String}   config.title       Dialog title / workspace action name.
 * @param {Object}   config.baseOptions Global tag options used as defaults.
 * @param {Object}   config.feature     GeoJSON feature being edited.
 * @param {String}   config.property    Tag property being edited (e.g. 'Nome', 'MediaMensal').
 * @param {Object}   config.scope       Persistence scope (client/user/layer/type).
 * @param {String|String[]} config.uniqueField Feature id property (default 'Id').
 * @param {Function} config.onSaved     Called after each style change is persisted.
 */
export const openTagStyleEditor = ({ title = '', baseOptions, feature, property, scope, uniqueField = 'Id', onSaved }) => {
    if (!feature || !feature.properties || !scope || !property) {
        return;
    }

    const idField = Array.isArray(uniqueField) ? 'Id' : uniqueField;
    const featureId = feature.properties[idField] || feature.properties.Id;

    if (featureId === null || typeof featureId === 'undefined') {
        return;
    }

    const saved = getFeatureTagStyle(feature, getSavedTagStyles(scope), uniqueField, property);
    const options = _.assign({}, baseOptions, saved || {});

    textStyle(title, {
        options,
        change: style => {
            saveTagStyle(scope, featureId, property, style);

            if (_.isFunction(onSaved)) {
                onSaved();
            }
        }
    });
};

export default openTagStyleEditor;



// WEBPACK FOOTER //
// ./src/scripts/core/dialog/tag-style-editor.js